import { ExpUtils } from '@/directive/exp'
import { spmReport } from '@/utils/report'

function beforeMount(el, binding, vnode) {
  const { value, arg, modifiers, instance } = binding
  const [eventId, data] = value
  const { repeat, rid } = modifiers

  if (arg === 'exp') {
    ExpUtils.beforeMount(
      el,
      {
        callback: () => {
          spmReport.reportElementSpmData(eventId, { ...data }, { rid })
        },
        repeat
      },
      vnode,
      instance
    )
  }
}

function updated(el, binding, vnode) {
  const { value, arg, modifiers, instance } = binding
  const [eventId, data] = value
  const { repeat, rid } = modifiers
  // 更新的时候也需要严格判断，否则会造成绑定事件污染
  if (arg === 'exp') {
    ExpUtils.updated(
      el,
      {
        value: binding.value,
        oldValue: binding.oldValue,
        callback: () => {
          spmReport.reportElementSpmData(eventId, { ...data }, { rid })
        },
        repeat
      },
      vnode,
      instance
    )
  }
}

function unmounted(el, binding) {
  const { arg } = binding
  if (arg === 'exp') {
    ExpUtils.unmounted(el)
  }
}

export default {
  beforeMount,
  updated,
  unmounted
}
